export default __webpack_public_path__ + "static/media/more.44ca45ec.svg";